import * as Stimulus from "@hotwired/stimulus"

/**
 * Put this controller directly on any element that contains text.
 * Will replace all strings that begin with http:// or https:// with
 * an <a> tag that links to the external link
 *
 * Not intended to be used on elements that already have <a> tags at
 * the moment of page load
 **/
export class LinkifyController extends Stimulus.Controller {
    connect() {
        var $el = this.element;
        if (this.#hasLinkTag($el)) {
            DEV: throw new Error('[LinkifyController] Controller element is or has an <a> tag');
            return;
        }
        $el.innerHTML = this.#linkify($el.innerHTML);
    }

    #hasLinkTag($el) {
        return $el.nodeName == 'A' || $el.querySelectorAll('a').length > 0
    }

    #linkify(text) {
        var exp = /(\bhttps?:\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        var result = text.replace(exp, "<a href=\"$1\" target=\"_blank\" rel=\"noopener\" class=\"underline\">$1</a>")
        return result;
    }
}
